import { render } from "./CoursesEvaluate.vue?vue&type=template&id=4c63cbc8&scoped=true"
import script from "./CoursesEvaluate.vue?vue&type=script&lang=js"
export * from "./CoursesEvaluate.vue?vue&type=script&lang=js"

import "./CoursesEvaluate.vue?vue&type=style&index=0&id=4c63cbc8&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c63cbc8"]])

export default __exports__